import React, { useMemo } from 'react';
import { Title, Description, BoldText, Content, Container, Wrapper, BackArrowIcon } from './styles';
import { useIntl } from 'react-intl';
import { CancelButtonBlock } from 'components/cancel-button';
import { useCancelBookingPage } from './useCancelBookingPage.hook';

interface CancelBookingPageProps {
  setIsCancelBookingStep?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CancelBookingPage = ({ setIsCancelBookingStep }: CancelBookingPageProps): JSX.Element => {
  const intl = useIntl();
  const {
    onBack,
    onCancelButtonClick,
    formattedDate,
    vendorName,
    isMobileDevice,
    showMiniappPaymentsNavigation,
    patchTransactionsStatus,
  } = useCancelBookingPage(setIsCancelBookingStep);
  const showBackButton = useMemo(
    () => !(showMiniappPaymentsNavigation && isMobileDevice),
    [showMiniappPaymentsNavigation, isMobileDevice],
  );

  return (
    <Container wrapping={showMiniappPaymentsNavigation && isMobileDevice ? 'externalModal' : 'internalModal'}>
      <Wrapper>
        <Content>
          {showBackButton && <BackArrowIcon onClick={onBack} data-testid="modal-wrapper-back-button" />}
          <Title>{intl.formatMessage({ id: 'cancel_booking?' })}</Title>
          <Description>
            {intl.formatMessage(
              { id: 'you_are_about_cancel_booking' },
              {
                vendorName: <BoldText>{vendorName}</BoldText>,
                bookingTime: (
                  <BoldText>
                    {`${formattedDate.eventWeekDay}, ${formattedDate.eventDateMonthLong} ${
                      formattedDate.eventDateDay
                    }, ${intl.formatMessage({
                      id: 'at',
                    })} ${formattedDate.formatEventStartTime}`}
                  </BoldText>
                ),
              },
            )}
          </Description>
        </Content>
        <CancelButtonBlock status={patchTransactionsStatus} onCancel={onCancelButtonClick} />
      </Wrapper>
    </Container>
  );
};
